import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'app/auth/service';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private _router: Router, private _authenticationService: AuthenticationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = localStorage.getItem('b2b_token');
    
    // If no token, redirect to login
    if (!token) {
      this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    try {
      // Decode the token to get user data
      const decodedToken: any = jwtDecode(token);
      const userRole = decodedToken.role || decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || '';

      // If route has role restrictions, check them
      if (route.data?.roles && !route.data.roles.includes(userRole)) {
        this._router.navigate(['/pages/miscellaneous/error']);
        return false;
      }

      return true;
    } catch (error) {
      // If token is invalid, redirect to login
      this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}